import { Component, OnInit, Input } from '@angular/core';
import { pushToObject } from 'src/app/services/mapping.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-doc-ref-display',
  templateUrl: './doc-ref-display.component.html',
  styleUrls: ['./doc-ref-display.component.scss']
})
export class DocRefDisplayComponent implements OnInit {
  @Input() bookKey:any;
  item:any;
  process:boolean=true;
  constructor(private ds:DataService) { }

  ngOnInit() {
    this.ds.booksRef().doc(this.bookKey).valueChanges().subscribe(doc=>{
      this.item=doc;
    })
  }

}
